import { ReactNode } from 'react';
import Footer from './Footer';
import { Document, Font, Page, StyleSheet } from '@react-pdf/renderer';
import Header from './Header';
import { DocumentProps, PageProps } from '@react-pdf/types';
import OpenSansRegular from '@/assets/fonts/OpenSans/OpenSans-Regular.ttf'
import OpenSansBold from '@/assets/fonts/OpenSans/OpenSans-Bold.ttf'

Font.register({
  family: 'OpenSans',
  fonts: [
    { src: OpenSansRegular },
    {
      src: OpenSansBold,
      fontWeight: 'bold',
    },
  ],
});

const styles = StyleSheet.create({
  page: {
    paddingTop: 28.9,
    paddingBottom: 57.8,
    paddingHorizontal: 28.9,
  },
});

const Layout = ({
                  reportName,
                  headerData,
                  children,
                  reportSettings,
                  signLineTexts
                }: {
  reportName: string;
  headerData: any;
  children: ReactNode;
  reportSettings?: {
    document?: Partial<DocumentProps>;
    page?: Partial<PageProps>;
  };
  signLineTexts?: string[];

}) => {
  return (
      <Document title={reportName} pdfVersion='1.7' {...reportSettings?.document}>
        <Page size='A4' style={styles.page} wrap {...reportSettings?.page}>
          <Header data={headerData} />
          {children}
          <Footer signLineTexts={signLineTexts} />
        </Page>
      </Document>
  );
};
export default Layout;
